import {yupResolver} from "@hookform/resolvers/yup";
import {FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";

export interface ChartNameFormValues {
  name: string;
}

// Mirrors MetricsExplorerView.name, so an over-long name is caught here rather than by the save.
const MAX_NAME_LENGTH = 100;

const FormSchema = Yup.object({
  name: Yup.string().trim().required("This field is required").max(MAX_NAME_LENGTH),
});

interface ChartNameFormProps {
  id: string;
  defaultName: string;
  onSubmit: (values: ChartNameFormValues) => void;
}

export const ChartNameForm = ({id, defaultName, onSubmit}: ChartNameFormProps) => {
  const methods = useForm<ChartNameFormValues>({
    resolver: yupResolver(FormSchema),
    defaultValues: {name: defaultName},
  });

  return (
    <FormProvider {...methods}>
      <form id={id} onSubmit={methods.handleSubmit(onSubmit)}>
        <InputField
          id={`${id}-name`}
          name="name"
          label="Name"
          placeholder="Response time by step"
          maxLength={MAX_NAME_LENGTH}
          required
        />
      </form>
    </FormProvider>
  );
};
